"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAccumulationRuleset = getAccumulationRuleset;
const federal_1 = require("./federal");
const layerRules_1 = require("./layerRules");
const state_1 = require("./state");
// Which rules apply to this facility at all. Choosing between the ones that
// do is `layerRules`' job.
function applicableTo(rules, ctx) {
    return rules.filter((rule) => {
        const areaTypeMatches = rule.areaType === ctx.areaType;
        const generatorStatusMatches = rule.generatorStatus === "ANY" ||
            (ctx.generatorStatus !== null && rule.generatorStatus === ctx.generatorStatus);
        const conditionMatches = rule.condition ? rule.condition(ctx) : true;
        return areaTypeMatches && generatorStatusMatches && conditionMatches;
    });
}
/**
 * Works out which accumulation limits apply to a facility: the federal rules,
 * with the facility state's own rules replacing them where that state has
 * them. Each returned rule carries the regulation it comes from.
 *
 * Comes to one rule per kind of limit for the rule sets shipped today, because
 * rules that would otherwise compete under one key are separated by mutually
 * exclusive conditions. That's a property of the content, not a guarantee this
 * function makes — see `layerRules`.
 */
function getAccumulationRuleset(ctx) {
    return (0, layerRules_1.layerRules)([
        { source: "FEDERAL", rules: applicableTo(federal_1.FEDERAL_RULES, ctx) },
        { source: "STATE", rules: applicableTo((0, state_1.getStateRules)(ctx.state), ctx) },
    ]);
}
//# sourceMappingURL=getAccumulationRuleset.js.map